/**
 * @generated SignedSource<<cc06afd0c355a169ce078c8043c6d587>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceTodoEditMainDeleteMutation$variables = {
  id: string;
};
export type WorkspaceTodoEditMainDeleteMutation$data = {
  readonly todoWorkspace: {
    readonly delete: {
      readonly id: string;
    };
  };
};
export type WorkspaceTodoEditMainDeleteMutation = {
  response: WorkspaceTodoEditMainDeleteMutation$data;
  variables: WorkspaceTodoEditMainDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoWorkspaceMutation",
    "kind": "LinkedField",
    "name": "todoWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "delete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dde209f183eb1378fcf3a9dd37ee381f",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainDeleteMutation(\n  $id: ID!\n) {\n  todoWorkspace(id: $id) {\n    delete {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "546d79570478f103ed629f455588fa8d";

export default node;
